import { useEffect, useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, Stack, IconButton, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'en',
    label: 'English',
    icon: '/assets/icons/ic_flag_en.svg',
  },
  {
    value: 'nl',
    label: 'Dutch',
    icon: '/assets/icons/ic_flag_nl.svg',
  },
  {
    value: 'fr',
    label: 'French',
    icon: '/assets/icons/ic_flag_fr.svg',
  },
  {
    value: 'lb',
    label: 'Lëtzebuergesch',
    icon: '/assets/icons/ic_flag_lu.png',
  },
];

// ----------------------------------------------------------------------

export default function LanguagePopover() {

  const [open, setOpen] = useState(null);
  const [country, setCountry] = useState(localStorage.getItem('language') ? localStorage.getItem('language') : "fr");
  const { t, i18n } = useTranslation();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = (menu) => {
    if (menu.value) {
      console.log(menu.value);
      setCountry(menu.value);
      i18n.changeLanguage(menu.value.toLowerCase())
      localStorage.setItem('language', menu.value.toLowerCase());
    }
    setOpen(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
          }),
        }}>
        <img src={LANGS.filter((l) => l.value === country.toLowerCase())[0].icon} alt={LANGS[0].label} style={{ width: 28 }} />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Stack spacing={0.75}>
          {LANGS.map((option) => (
            <MenuItem key={option.value} selected={option.value === country} onClick={(e) => handleClose({ value: option.value })}>
              <Box component="img" alt={option.label} src={option.icon} sx={{ width: 28, mr: 2 }} />
              {t(option.label)}
            </MenuItem>
          ))}
        </Stack>
      </Popover>
    </>
  );
}
